module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-72-min.dd3125cf.jpg";